export default {
  // list
  'posts.query.postName': 'Post Name',
  'posts.query.postName.placeholder': 'Enter post name',
  'posts.column.postName': 'Post Name',
  'posts.column.code': 'Post Code',
  'posts.column.status': 'Status',
  'posts.column.status.normal': 'Active',
  'posts.column.status.disabled': 'Disabled',
  'posts.importDialog.tip': 'Status field options: Active, Disabled',
  // edit
  'posts.edit.title': 'Edit Post',
  'posts.add.title': 'Add Post',
  'posts.edit.success': 'Edit Successful',
  'posts.add.success': 'Addition Successful',
  'posts.form.postName': 'Post Name',
  'posts.form.postName.placeholder': 'Please enter the post name',
  'posts.form.postName.required': 'Post name cannot be empty',
  'posts.form.code': 'Post Code',
  'posts.form.code.placeholder': 'Please enter the post code',
  'posts.form.code.required': 'Post code cannot be empty',
  'posts.form.status': 'Post Status',
  'posts.form.status.required': 'Post status cannot be empty',
  'posts.form.status.normal': 'Active',
  'posts.form.status.disabled': 'Disabled'
}
